import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@5.2.1@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_videoList_start",
  "use": "icon-icon_videoList_start-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_videoList_start\">\n<path d=\"M19.5988 11.6461C20.2383 12.0358 20.2383 12.9642 19.5988 13.3539L9.0204 19.8007C8.35402 20.2068 7.5 19.7271 7.5 18.9467L7.5 6.05325C7.5 5.27287 8.35402 4.79322 9.0204 5.19933L19.5988 11.6461Z\" stroke=\"\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol